import type { RoleNames } from '@env/environment.type';

export type Role = keyof RoleNames;

export const rolesFromGroups = (
  groups: readonly string[],
  roleGroups: { prefix: string; names: RoleNames },
): string[] => {
  const matched = new Set<string>();
  const entries = Object.entries(roleGroups.names);
  for (const rawGroup of groups) {
    const group = rawGroup.startsWith('/') ? rawGroup.slice(1) : rawGroup;
    if (!group.startsWith(roleGroups.prefix)) {
      continue;
    }
    const name = group.slice(roleGroups.prefix.length);
    for (const [role, configuredName] of entries) {
      if (name === configuredName) {
        matched.add(role);
      }
    }
  }
  return [...matched];
};
